<template>
    <div
        class="richTable-row text-primary contact-shop mt-1"
        :shop_id="data.id"
        :contact_person_name="contact.contact_person_name"
        :contact_person_email="contact.contact_person_email"
    >
        <div class="richTable-col" style="--width-md: 30%">
            <div class="richTable-headline">
                <div class="d-flex justify-content-between">
                    <div>
                        Nazwa sklepu
                    </div>
                    <div>
                        <ui-checkbox-input
                            large
                            :name="`customCheck${data.id}`"
                            v-model="selectedContact"
                            :disabled="!enableCheckbox"
                        />
                    </div>
                </div>
            </div>
            <p>{{ data.name }}</p>
            <p>({{ setShopAddress }})</p>
        </div>
        <div class="richTable-col" style="--width-md: 20%">
            <div class="richTable-headline">
                Osoba kontaktowa
            </div>
            <input
                type="text"
                v-model="contact.contact_person_name"
                @input="checkInputs"
                class="form-control cux-exclude"
                :placeholder="
                    contacts && contacts.contact_person_name
                        ? contacts.contact_person_name
                        : 'Wpisz os. kontaktową'
                "
            />
        </div>
        <div class="richTable-col" style="--width-md: 30%">
            <div class="richTable-headline">
                Adres e-mail
            </div>
            <input
                type="text"
                v-model="contact.contact_person_email"
                @input="checkInputs"
                class="form-control cux-exclude"
                :placeholder="
                    contacts && contacts.contact_person_email
                        ? contacts.contact_person_email
                        : 'Wpisz adres e-mail'
                "
            />
        </div>
        <div class="richTable-col text-right" style="--width-md: 20%">
            <div class="richTable-check d-md-flex  justify-content-end d-none">
                <ui-checkbox-input
                    large
                    :name="`customCheck${data.id}`"
                    v-model="selectedContact"
                    :disabled="!enableCheckbox"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            contact: {
                shop_id: this.data.id,
                contact_person_name: '',
                contact_person_email: ''
            },
            enableCheckbox: false
        }
    },
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    methods: {
        checkInputs() {
            this.$store.dispatch('labelsShopContactUpdate', this.contact)
            if (
                this.contact.contact_person_name &&
                this.contact.contact_person_email
            ) {
                const isEmail = (email = null) => {
                    // eslint-disable-next-line
                    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return regex.test(email)
                }
                this.enableCheckbox = isEmail(this.contact.contact_person_email)
            } else {
                this.enableCheckbox = false
            }
            if (this.enableCheckbox === false) {
                this.selectedContact = false
            }
        },
        updateValues() {
            if (this.contacts) {
                this.contact.shop_id = this.contacts.shop_id
                this.contact.contact_person_name = this.contacts.contact_person_name
                this.contact.contact_person_email = this.contacts.contact_person_email
                this.enableCheckbox = true
            }
        }
    },
    computed: {
        contacts() {
            return this.$store.getters.getLabelGroupsShopContactById(
                this.data.id
            )
        },
        selectedContact: {
            get() {
                const contact = this.$store.getters.getLabelGroupsShopContactById(
                    this.data.id
                )
                return contact && contact.selected
            },
            set(value) {
                this.$store.dispatch('selectLabelGroupsShopContact', {
                    ...this.contact,
                    selected: value
                })
            }
        },
        setShopAddress() {
            const data = this.data
            return this.$store.getters.getShopAddress(data)
        }
    },
    mounted() {
        this.updateValues()
    },
    watch: {
        contacts() {
            this.updateValues()
        }
    }
}
</script>
